import { Circle } from '@mui/icons-material'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { type ChildDuplicate } from 'slices/duplicateChildSlice'

interface Props {
  dupeData: ChildDuplicate
  acceptanceThreshold?: number
}

export function ProbabilityChip (props: Props): JSX.Element {
  const { dupeData, acceptanceThreshold } = props
  const matchPercent = (dupeData.probability ?? 0)
  const highProbability = acceptanceThreshold !== undefined && matchPercent >= acceptanceThreshold
  const style = highProbability
    ? {
        border: '1px solid #BC3656',
        background: 'rgba(188, 54, 86, 0.1)',
        color: '#BC3656'
      }
    : {
        border: '1px solid black',
        background: 'rgba(239, 205, 78, 0.1)'
      }

  return <Chip
    icon={<Circle sx={{ fontSize: 11, color: `${style.color ?? 'black'} !important` }} />}
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    label={<Typography sx={{ fontWeight: '600', fontSize: '14px' }}>{`${highProbability ? 'High' : 'Medium'}: ${matchPercent}`}</Typography> }
    variant='outlined'
    sx={{ ...style, paddingX: '12px' }}
  />
}
